import { PassengerConfirmTripUpdateInput, TripOutput } from '@allocab/allocab-passenger-shared-types';
import { useMutation } from '@tanstack/react-query';

import { mutationKeys } from '../services/datastore/mutationKeys';
import { queryKeys } from '../services/datastore/queryKeys';
import { queryClient } from '../services/datastore/react-query';
import { passengerApi } from '../services/network/Api';
import { APIError } from '../services/network/types';

type Input = PassengerConfirmTripUpdateInput & { key: string };

const confirmUpdate = ({ key, ...input }: Input) =>
  passengerApi.post<PassengerConfirmTripUpdateInput, TripOutput>(`v2/trip/${key}/confirm-update`, input);

export const useConfirmUpdate = (key: string) => {
  const confirmUpdateMutation = useMutation<TripOutput, APIError, Input>({
    mutationKey: mutationKeys.confirmUpdateTrip(key),
    mutationFn: confirmUpdate,
    onSuccess: trip => {
      queryClient.setQueryData(queryKeys.user.fetchTrip(trip.id), trip);
    },
  });

  return confirmUpdateMutation;
};
